module.exports = __webpack_public_path__ + "static/media/elobo.6bf1dc53.jpg";